import React, { useState } from 'react'
import { config } from '../config'
import UserIcon from "../../../assets/images/user.webp"
import moment from 'moment'
import { Modal } from 'antd'


const InstructorSelection = ({ instructors, setSelectedInstructor, selected_instructor, setTimeSlot }) => {

    const checkSelected = (ins_id) => {
        return (
            selected_instructor?.id === ins_id
        )
    }

    const [Open, setOpen] = useState(false);
    const [InstructorDetails, setInstructorDetails] = useState([]);

    return (
        <div>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>Choose Instructor</h2>
                <p>Just a few questions to determine the type of lesson or course you would like.</p>
            </div>

            <div className='row mt-4'>
                {
                    instructors.length > 0 && instructors.map((item) => {

                        const selectedItem = checkSelected(item.id) ?
                            { className: 'selected_ins', btn_text: 'Selected' } :
                            { className: 'px-2', btn_text: 'Choose Me' }

                        return (
                            <div key={item.id} className="col-xl-6">
                                <div className='input-white-box d-block px-3'>

                                    <div className='d-md-flex align-items-center '>
                                        <div className='d-flex align-items-center'>
                                            <div>
                                                <img src={item.image ? `${config.imageUrl}${item?.image}` : UserIcon}
                                                    style={{width: "50px", height: '50px'}}
                                                alt="" />
                                            </div>
                                            <div className='ms-2'>
                                                <h6 className='mb-1'>{item.name}</h6>
                                                {/* <hr /> */}
                                                <p>{item.location}</p>
                                            </div>
                                        </div>
                                        <div className="text-md-end text-start mt-md-0 mt-3" style={{ flex: 1 }}
                                            onClick={() => {
                                                if (selected_instructor?.id !== item.id)
                                                    setTimeSlot({
                                                        date: moment(new Date()).format("YYYY-MM-DD"),
                                                        time: ''
                                                    })
                                                setSelectedInstructor(item)
                                            }}>
                                            <button type='button' className={`${selectedItem.className} `}>
                                                {selectedItem.btn_text}
                                            </button>
                                            <button type='button' className='bg-black' style={{ height: "fit-content" }}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent the div's onClick from firing
                                                    setInstructorDetails(item);
                                                    setOpen(true);
                                                }}
                                            >
                                                <i className='bi bi-eye text-white'></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    instructors.length === 0 && (
                        <div className="col-md-6">
                            <div className='input-white-box d-block px-3'>

                                <div className='d-md-flex align-items-center '>
                                    <div className='d-flex align-items-center'>
                                        <div className='ms-2'>
                                            <h6 className='mb-1'>No Instructors Found!</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

            <Modal
                open={Open}
                onCancel={() => setOpen(false)}
                width={800}
                centered
                footer={null}
                bodyStyle={{ padding: '0', background: "#fff" }}
            >
                <div  >
                    <div className=''>
                        <div className="therapist-info">
                            <div className="row p-4 pt-5" style={{ background: "#fff" }}>
                                <div className="col-md-4 pe-3">
                                    <img src={InstructorDetails?.image ? `${config.imageUrl}${InstructorDetails?.image}` : UserIcon} alt="" className='img-fluid rounded-4' />
                                    <h5 className='fw-bold mt-3 ps-2 mb-2'> {InstructorDetails?.name} </h5>
                                    <h6 className='fw-600 ps-2'>{`${InstructorDetails?.experience} Years of Experience`}</h6>
                                </div>
                                <div className='col-md-8 instructor-data' style={{ height: '310px', overflow: 'auto', scrollbarWidth: 'thin' }}>
                                    <h5 className='mb-3 fs-4 text-black'>{'Location : '}{" "}{InstructorDetails?.address}</h5>
                                    <p className='fs-6'>
                                        {InstructorDetails?.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </div>
    )
}

export default InstructorSelection